import { ButtonLink } from "../../../elements"

const ContactButton = () => {
  return (
    <ButtonLink to="https://jp.josys.com/contact" $shadow $size="lg">
      お問い合わせ
    </ButtonLink>
  )
}

export { ContactButton }
